export default function StatCard({ label, value, subValue, icon, variant = "default" }) {
  return (
    <div className={`stat-card ${variant}`}>
      <div className="stat-card__top">
        <div className="stat-label">{label}</div>
        {icon && <div className="stat-icon">{icon}</div>}
      </div>
      <div className="stat-value">{value}</div>
      {subValue && <div className="stat-sub">{subValue}</div>}
    </div>
  );
}
